import { render, staticRenderFns } from "./ModeratedMessageList.vue?vue&type=template&id=79d354f1&scoped=true&"
import script from "./ModeratedMessageList.vue?vue&type=script&lang=js&"
export * from "./ModeratedMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ModeratedMessageList.vue?vue&type=style&index=0&id=79d354f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d354f1",
  null
  
)

export default component.exports